import { render, staticRenderFns } from "./MiniTabulator.vue?vue&type=template&id=5b0bdea8&scoped=true&"
import script from "./MiniTabulator.vue?vue&type=script&lang=js&"
export * from "./MiniTabulator.vue?vue&type=script&lang=js&"
import style0 from "./MiniTabulator.vue?vue&type=style&index=0&id=5b0bdea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0bdea8",
  null
  
)

export default component.exports